/**
 * Where measurement may leave the page (shell request 2026-09-11: a local smoke test sent a real
 * GA4 hit to the production property).
 *
 * Vendor scripts are injected, and events handed to them, only on the production hosts. On every
 * other host (Vite, `server/serve.mjs`, parity rigs, previews) measurement behaves identically —
 * attribution, client id, consent storage, banner, queue and page-view timing — except that no
 * vendor script is injected and no hit is sent.
 *
 * Test-only override: a bundle built with `vite build --mode e2e` also treats the loopback hosts as
 * production, so Playwright can observe the loaders (`dataLayer`, injected `<script>` tags) while its
 * fixture aborts every vendor request. It cannot take effect in production: the release build runs in
 * `production` mode, where `import.meta.env.MODE === 'e2e'` is replaced by `false` and the branch is
 * removed from the bundle; and even an e2e bundle extends the list only to `localhost`/`127.0.0.1`.
 */

export const PRODUCTION_HOSTS: readonly string[] = ['mutatio618.com', 'www.mutatio618.com'];

/** Hosts an e2e-mode bundle treats as production. */
export const E2E_LOOPBACK_HOSTS: readonly string[] = ['localhost', '127.0.0.1'];

/**
 * May vendors load on `hostname`? Exact, case-insensitive host match; no suffix or port matching.
 * The mode comparison is written inline so the release build folds it to `false` and drops the branch.
 */
export function vendorsPermitted(hostname: string): boolean {
  const host = hostname.toLowerCase();
  if (PRODUCTION_HOSTS.includes(host)) return true;
  return import.meta.env.MODE === 'e2e' && E2E_LOOPBACK_HOSTS.includes(host);
}
